import { render, staticRenderFns } from "./IdentityResourceList.vue?vue&type=template&id=5a8bf264&"
import script from "./IdentityResourceList.vue?vue&type=script&lang=js&"
export * from "./IdentityResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports